import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"margin":"20px auto 50px"} }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { style: {"overflow":"hidden","margin-top":"10px"} }
const _hoisted_5 = ["id", "onClick"]

import { reactive, toRefs } from 'vue';
import { useStore } from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'model-list',
  props: {
    dataList:Array as any
},
  setup(__props) {

const props = __props

const store = useStore()
const { dataList } = toRefs(props)

const data = reactive({
    readonly: 1,
    value: {},  //  点击的数据
})

const clickOption = (value: object) => {
    data.value = value
    // 点击该选项以后,如果此选项为已选中则不做操作.
    // 如果此选项为未选中则变为已选中,将选中节点的下一节点改为显示,将此节点的全部兄弟节点的子节点改为隐藏状态
    store.commit('setModelValue',value)
    if(data.readonly === 0 ){
        return false
    }
}


return (_ctx: any,_cache: any) => {
  const _component_model_list = _resolveComponent("model-list", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataList), (item, i) => {
      return (_openBlock(), _createElementBlock("div", { key: i }, [
        (item.status == 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.name), 1),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (value, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    id: value.id,
                    onClick: ($event: any) => (clickOption(value)),
                    key: value.id,
                    class: "button-div"
                  }, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["answer", [{ markAnswer: value.status == 1},{ markAnswer2: value.status != 1}]])
                    }, _toDisplayString(value.name), 3)
                  ], 8, _hoisted_5))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (item2) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item2.id,
                  style: {"margin-top":"20px"}
                }, [
                  _createVNode(_component_model_list, {
                    dataList: item2.children,
                    readonly: data.readonly
                  }, null, 8, ["dataList", "readonly"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})